import React from "react";
import {Box, Card, CardContent, Container, Typography} from "@mui/material";
import {getAllSets, KeywordSet} from "../Data/KeywordSet.ts";
import { useNavigate } from "react-router";

export function MainPage(): React.ReactElement {
	const navigate = useNavigate();

	function renderKeywordSet(keywordSet: KeywordSet): React.ReactElement {
		return <Box
			onClick={() => navigate(`/${keywordSet.id}`)}
			sx={{
				cursor: "pointer",
			}}
		>
			<Card>
				<CardContent>
					<Typography variant="h5" component="div">
						{keywordSet.name}
					</Typography>
					<Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
						{keywordSet.description}
					</Typography>
				</CardContent>
			</Card>
		</Box>
	}

	return <Container
		maxWidth="lg"
		sx={{
			textAlign: "center",
			my: 3,
			display: "grid",
			gap: 2
	}}>
		{getAllSets().map(renderKeywordSet)}
	</Container>
}
